import { render, staticRenderFns } from "./ApplianceForm.vue?vue&type=template&id=6bcc11fb"
import script from "./ApplianceForm.vue?vue&type=script&lang=js"
export * from "./ApplianceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports